module.exports = __webpack_public_path__ + "fonts/sourcesanspro-bold-webfont.847a4b56.woff2";